/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SettingManagementCreateSettingResponse } from './SettingManagementCreateSettingResponse';

export type SettingManagementCreateSettingResponseApiRespoonse = {
    data?: SettingManagementCreateSettingResponse;
    status?: SettingManagementCreateSettingResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace SettingManagementCreateSettingResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

